import manifest from "./preservation-manifest.json";
import type { RouteId } from "../routing/routes";

export type RailEntry = {
  label: string;
  anchor: string;
  runtime?: boolean;
};

export type SourceCard = {
  id: string | null;
  labels: string[];
  title: string;
  blurb?: string;
  urls: string[];
  linkTexts?: string[];
};

export const preservationManifest = manifest;

export function getRailEntries(route: RouteId): RailEntry[] {
  const rail = manifest.rails[route];
  return rail?.entries ?? [];
}

export function getSourceCards(): SourceCard[] {
  return manifest.sourceCardsOrdered as SourceCard[];
}

export function getExternalUrlMultiset(): string[] {
  return manifest.externalUrlMultiset;
}

export function getEarth3Opening() {
  return manifest.earth3Opening;
}

export function getLivingCrossingMeta() {
  return manifest.accessibilityCopy;
}

export function getOperatingSpine() {
  return manifest.operatingSpine;
}

export function getLivingCrossingNodes() {
  return manifest.livingCrossingNodes;
}
